import * as React from "react";
import { useState, useEffect } from "react";
import { UnmountClosed } from "react-collapse";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { ProductSort } from "../../../../../Wrap/Constants/Enums/Domain/ProductSort";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SortDirection } from "../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { ModelPortfolioSearchQuery } from "../../../../../Wrap/Models/Domains/ModelPortfolio/ModelPortfolioSearchQuery";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { AllocationTableItem } from "../../Store/SelectedInvesmentStoreStatic";
import { PortfolioResults } from "./PortfolioResults";

interface IHubPortfolioSearchProps {
    hiercharyId: string;
    type: SubAccountType;
    tableData: AllocationTableItem[];
}

export const HubPortfolioSearch = (props: IHubPortfolioSearchProps) => {
    const [showResults, setShowResults] = useState(false);
    const [managerOptions, setManagerOptions] = useState([]);
    const [manager, setManager] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [productType, setProductType] = useState(null);
    const [data, setData] = useState(null);

    const getManagerOptions = () => {
        InvestmentSelectionAction.getInvestmentManager(props.hiercharyId, (data) => {
            setManagerOptions(data);
        });
    };

    useEffect(() => {
        getManagerOptions();
    }, []);

    const search = (index) => {
        const query: ModelPortfolioSearchQuery = {
            ManagerIds: manager ? [manager] : null,
            CurrentPage: index,
        };
        query["CanBeBought"] = true;
        query["ProductTypes"] = productType ? [productType] : null;
        query["ProductWrapperTypes"] = [props.type];
        query["Sorting"] = [{ Field: ProductSort.Name, Direction: SortDirection.Ascending }];
        setIsSearching(true);
        InvestmentSelectionAction.searchHubPortfolio(query, props.hiercharyId, (data) => {
            setIsSearching(false);
            setData(data);
            showTableResults();
        });
    };

    const showTableResults = () => {
        setShowResults(true);
    };

    return (
        <>
            <div className="ist-advanced-panel">
                <div className="row">
                    <div className="col-fluid">
                        <SelectEditor
                            label="Investment manager"
                            options={managerOptions}
                            getText={(o) => o.Name}
                            onChange={(v) => setManager(v?.Id)}
                            placeholder="Please select"
                        />
                    </div>
                    <div className="col-fluid">
                        <SelectEditor
                            label="Portfolio type"
                            placeholder="Please select"
                            options={[ProductType.ManagedModelPortfolio, ProductType.TailoredModelPortfolio]}
                            getText={(o) => (o == ProductType.ManagedModelPortfolio ? "MPS (incl PPM)" : "IMA")}
                            onChange={(v) => {
                                setProductType(v);
                            }}
                        />
                    </div>
                </div>
                <div className="text-right">
                    <button
                        onClick={() => search(1)}
                        type="button"
                        className={`btn secondary ${isSearching ? "is-busy" : ""}`}
                    >
                        Search
                    </button>
                </div>
            </div>

            <UnmountClosed isOpened={showResults}>
                <PortfolioResults data={data} allocationTable={props.tableData} onPageChange={(i) => search(i)} />
            </UnmountClosed>
        </>
    );
};
